<script setup lang="ts">

//vue
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";

//services
import * as clienteService from "@/services/clienteService";
import storeControle from "@/utils/storeControle";
import { getToken } from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";

const router = useRouter();

var controle = reactive({
  model: {} as clienteService.ClienteLogin,
  status: "" as string,
  erro: "" as string,
  tipoSenha: "password" as string
})


function login() {

  // Lógica de login aqui
  controle.status = "Realizando login...";
  console.log("Login:", controle.model);

  clienteService.Login(controle.model)
    .then((r) => {
      storeControle.usuario = {} as clienteService.ClienteLoginResult;
      storeControle.token = r.accessToken;
      storeControle.usuario.clienteId = r.clienteId;
      storeControle.usuario.nome = r.nome;
      storeControle.usuario.refreshToken = r.refreshToken;
      storeControle.usuario.userName = r.userName;

      controle.status = "Entrando...";
      console.log("Entrando com sucesso:", r);

      // Armazenar o token no localStorage ou cookies, se necessário
      localStorage.setItem("clienteToken", r.accessToken);
      localStorage.setItem('user', JSON.stringify(r));

      // Redirecionar para a área do cliente após o login bem-sucedido

      router.push({ name: "PainelCliente" });
    })
    .catch((error) => {
      controle.status = "";
      controle.erro = error.message || error;
    });
}


</script>
<template>

  <div class="row">

  </div>


  <div class="row">

    <div class="col-md-3">

    </div>

    <div class="col-md-6">

      <div class="row">
        <div class="col-md-12 text-center">
          <h2 class="mt-4 mb-3">Área do Cliente - Login</h2>
        </div>

        <div class="col-md-12 text-center">
          <img :src="imgLogin" alt="Login do Cliente" class="img-fluid">
        </div>
      </div>

      <div class="row">  

        <div class="mb-3">
          <label for="cpf" class="form-label">CPF</label>
          <input type="text" class="form-control" id="cpf" placeholder="Digite seu CPF"
            inputmode="numeric" autocomplete="username" maxlength="14"
            v-model="controle.model.cpf" @keyup.enter="login()">
        </div>

        <div class="mb-3">
          <label for="senha" class="form-label">Senha</label>
          <div class="input-group">
            <input :type="controle.tipoSenha" class="form-control" id="senha" placeholder="Digite sua senha"
              autocomplete="current-password"
              v-model="controle.model.senha" @keyup.enter="login()">
            <span class="input-group-text" role="button"
              @click="controle.tipoSenha = (controle.tipoSenha === 'password' ? 'text' : 'password')">
              <i class="flaticon-eye"></i>
            </span>
          </div>
        </div>

        <div class="col-md-12 d-grid gap-2">
          <button type="button" class="btn btn-primary" @click="login()">Entrar</button>
        </div>

        <div class="mt-3 text-primary" v-if="controle.erro == ''">
          {{ controle.status }}
        </div>

        <div class="mt-3 text-danger" v-if="controle.erro != ''">
          {{ controle.erro }}
        </div>
      </div>
    </div>

    <div class="col-md-3">

    </div>
  </div>
</template>